export default "/list/static/images/shield.svg";